<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="position-relative grid-content">
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
        </div>
      </div>
      <div class="d-flex gap-3">
        <div id="header-container">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                [(ngModel)]="searchValue" />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="table-container">
    <table class="dynamic-table-container">
      <th style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div>
            <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="parentCheckBox"
              (change)="dataGridParentCheckBoxChecked($event)">
          </div>
        </div>
      </th>

      <th style="min-width: 150px;max-width:150px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'"> <span>From Name</span> <span class="fa-solid fa-filter grid-header-container"></span>
      </th>
      <th *ngIf="qmsservice.activityId !=null" style="min-width: 180px;max-width:180px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>To Emails</span> <span class="fa-solid fa-filter grid-header-container"></span>
      </th>
      <th *ngIf="qmsservice.activityId !=null" style="min-width: 240px;max-width:240px; text-align: left;overflow: hidden;text-overflow: ellipsis;
        white-space: nowrap"> <span>CC Emails</span> <span class="fa-solid fa-filter grid-header-container"></span>
      </th>
      <th style="min-width: 240px;max-width:240px;text-align: left;overflow: hidden;text-overflow: 'ellipsis';
         white-space: 'nowrap'"> <span>Subject</span>
        <span class="fa-solid fa-filter grid-header-container"></span>
      </th>
      <th style="min-width: 120px;max-width:120px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"> <span>Content</span> <span class="fa-solid fa-filter grid-header-container"></span>
      </th>
      <th *ngIf="qmsservice.activityId !=null" style="min-width: 150px;max-width:150px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"> <span>Message</span> <span class="fa-solid fa-filter grid-header-container"></span>
      </th>
      <th style="min-width: 150px;max-width:150px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"> <span>Status</span> <span class="fa-solid fa-filter grid-header-container"></span>
      </th>
      <th *ngIf="qmsservice.activityId ==null" style="min-width: 150px;max-width:150px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"> <span>Sent On</span> <span class="fa-solid fa-filter grid-header-container"></span>
      </th>
      <th id="menu" class="sticky-col first-col"></th>
      <tr *ngFor="let task of pagedItems | searchFilter : searchValue; let idx = index;">
        <td style="width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div [ngClass]="task.childCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div>
              <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                (change)="dataGridChildCheckBoxChecked($event, task, idx)">
            </div>
          </div>
        </td>
        <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"><span>{{task.fromName}}</span></td>
        <td *ngIf="qmsservice.activityId !=null" style="min-width: 240px;max-width:240px;text-align: left;overflow: hidden;text-overflow: 'ellipsis';
              white-space: 'nowrap'"><span>{{task.toEmails}}</span></td>
        <td *ngIf="qmsservice.activityId !=null" style="min-width: 240px;max-width:240px;text-align: center;overflow: hidden;text-overflow: ellipsis;
           white-space: nowrap"><span>{{task.ccEmails}}</span></td>
        <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{task.subject}}</span></td>
        <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="downloadButton" (click)="openDetailPage(task)">
              <i class="fa-solid fa-download"></i> View
            </button>
          </div>
        </td>
        <td *ngIf="qmsservice.activityId !=null" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{task.message}}</span></td>
        <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
             white-space: 'nowrap'"><span>{{task.status}}</span></td>
        <td *ngIf="qmsservice.activityId ==null" style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"><span>{{task.sentOn | date:'dd-MMM-yyyy HH:mm:ss'}}</span></td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="htmlContent">

    </div>
  </div>
</ng-template>
